module.exports = __webpack_public_path__ + "static/media/check.91ed687c.svg";